import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../store';

const selectRoot = ({ shops }: RootState) => shops;

export const selectShop = createSelector(
    selectRoot,
    ({ shopList }) => shopList,
);
